import React from 'react';
import { useParams, useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { SetDetailView } from './SetDetailView';

const SetDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Detect if accessed from student page - lock in value from initial mount
  const [isStudentMode] = React.useState(() => location.pathname.startsWith('/student'));
  const baseUrl = isStudentMode ? '/student/flashcards' : '/flashcards';

  const handleBack = () => {
    const from = searchParams.get('from');
    const folderId = searchParams.get('folderId');
    
    if (from === 'folder' && folderId) {
      // Return to folder detail
      navigate(`${baseUrl}/folders/${folderId}`);
    } else {
      // Return to sets list
      navigate(`${baseUrl}?tab=sets`);
    }
  };

  const handleEdit = () => {
    navigate(`${baseUrl}/sets/${id}/edit`);
  };

  const handleQuiz = () => {
    // Check if this is a challenge mode - passed via state
    const state = location.state as any;
    if (state?.isChallenge) {
      // In challenge mode, navigate to quiz with challenge data
      const from = searchParams.get('from');
      const folderId = searchParams.get('folderId');
      let url = `${baseUrl}/sets/${id}/quiz`;
      if (from && folderId) {
        url += `?from=${from}&folderId=${folderId}`;
      }
      navigate(url, { state });
    } else {
      // Normal quiz flow
      const from = searchParams.get('from');
      const folderId = searchParams.get('folderId');
      let url = `${baseUrl}/sets/${id}/quiz`;
      if (from && folderId) {
        url += `?from=${from}&folderId=${folderId}`;
      }
      navigate(url);
    }
  };

  const handleMatching = () => {
    // Check if this is a challenge mode - passed via state
    const state = location.state as any;
    if (state?.isChallenge) {
      // In challenge mode, navigate to matching with challenge data
      const from = searchParams.get('from');
      const folderId = searchParams.get('folderId');
      let url = `${baseUrl}/sets/${id}/matching`;
      if (from && folderId) {
        url += `?from=${from}&folderId=${folderId}`;
      }
      navigate(url, { state });
    } else {
      // Normal matching flow
      const from = searchParams.get('from');
      const folderId = searchParams.get('folderId');
      let url = `${baseUrl}/sets/${id}/matching`;
      if (from && folderId) {
        url += `?from=${from}&folderId=${folderId}`;
      }
      navigate(url);
    }
  };

  if (!id) {
    return <div>Invalid set ID</div>;
  }

  return (
    <SetDetailView
      setId={Number(id)}
      onBack={handleBack}
      onEdit={handleEdit}
      onQuiz={handleQuiz}
      onMatching={handleMatching}
      from={searchParams.get('from') || undefined}
    />
  );
};

export default SetDetailPage;
